// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkout-header__top[data-v-975993be]{align-items:center;background-color:var(--color-bg-1);display:flex;gap:0;height:var(--header-size);justify-content:space-between}@media(min-width:575px){.checkout-header__top[data-v-975993be]{gap:var(--spacing-sm-2)}}@media(min-width:1024px){.checkout-header__top[data-v-975993be]{gap:var(--spacing-md-3)}}.checkout-header__wrapper[data-v-975993be]{display:flex;flex-direction:row}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
